import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import {openModal, closeModal} from 'Skelet/src/modules/functions.js'
import Labels from 'Skelet/src/components/Labels.js'
import ModalCreateContact from './ModalCreateContact.js'
import ModalUpdateContact from './ModalUpdateContact.js'
import refresh_icon from './28406.svg';


class Contacts extends React.Component {

  constructor(props) {
    super(props);
    this.state = {page:0, modal_create_open:false, modal_update_open:false, modal_content:{}, sortbyname:true};

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "contact_list", "GET", config.api_url+"/contact-list?t="+this.props.session_token, undefined, {"PM-List-Page":this.state.page});
      this.props.fetchDataIfReady(config.api_token, "label_list", "GET", config.api_url+"/label-list?t="+this.props.session_token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "contact_list", "GET", config.api_url+"/contact-list?t="+nextProps.session_token);
      this.props.fetchDataIfUndefined(config.api_token, "label_list", "GET", config.api_url+"/label-list?t="+nextProps.session_token);
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleScroll(e) {
    let window_bottom = window.pageYOffset + window.innerHeight;
    let list_bottom = this.wrapperRef.offsetTop + this.wrapperRef.scrollHeight;
    if (window_bottom >= list_bottom) {
      let page_cards = this.props.apiData["contact_list"];
      if(page_cards !== undefined && !page_cards.isFetching && !page_cards.limitReached) {
        let new_page = (this.state.page+1);
        this.setState({page:new_page});
        this.props.fetchDataIfReady(config.api_token, "contact_list", "GET", config.api_url+"/contact-list?t="+this.props.session_token, undefined, {"PM-List-Page":new_page}, false, true);
      }
    }
  }

  render() {
    let card = null, cards = null, end_of_list_text = "", list_title = "", page_cards = this.props.apiData["contact_list"], label_list = this.props.apiData["label_list"];
    if(page_cards !== undefined && label_list !== undefined) {
      if(this.state.sortbyname) {
        let divided = {a:false,b:false,c:false,d:false,e:false,f:false,g:false,h:false,i:false,j:false,k:false,l:false,m:false,n:false,o:false,p:false,q:false,r:false,s:false,t:false,u:false,v:false,w:false,x:false,y:false,z:false,"##":false};
        let first_divider = true;

        cards = page_cards.data.map(function(item, i) {
          let divider = "";
          let first_letter = item.name[0].toLowerCase();
          let first_letter_display = first_letter;

          if(divided[first_letter] === undefined) {
            first_letter = "##";
            first_letter_display = "#";
          }

          if(divided[first_letter] === false) {
            divided[first_letter] = true;
            divider = <div className={"divider"+(first_divider ? " first-divider" : "")}>{first_letter_display}</div>;
            if(first_divider) {
              first_divider = false;
            }
          }

          return <div key={"1k"+i}>{divider}<div className="contact" onClick={(e) => openModal(this, e, item, "modal_update_open")}>
            <div className="contact-name">{item.name}</div>
            <Labels label_list={label_list} item_labels={item.labels} displayMode />
          </div></div>;
        }.bind(this));
        card = <div className="card contacts">{cards}</div>;
      } else {
        let first_divider = true;
        let sorted = Object.assign([], page_cards.data);
        sorted = sorted.sort((a,b) => (a.created_on > b.created_on) ? -1 : ((b.created_on > a.created_on) ? 1 : 0));

        cards = sorted.map(function(item, i) {
          let d = new Date(item.created_on);
          let hrs = (d.getHours() < 10) ? "0"+d.getHours() : d.getHours();
          let mins = (d.getMinutes() < 10) ? "0"+d.getMinutes() : d.getMinutes();
          let secs = (d.getSeconds() < 10) ? "0"+d.getSeconds() : d.getSeconds();
          let day = (d.getDate() < 10) ? "0"+d.getDate() : d.getDate();
          let mnt = ((d.getMonth()+1) < 10) ? "0"+(d.getMonth()+1) : (d.getMonth()+1);
          let yr = (d.getFullYear() < 10) ? "0"+d.getFullYear() : d.getFullYear();
          let divider = <div className={"divider"+(first_divider ? " first-divider" : "")}>{hrs+":"+mins+":"+secs} ({day+"-"+mnt+"-"+yr})</div>;
          first_divider = false;

          return <div key={"1k"+i}>{divider}<div className="contact" onClick={(e) => openModal(this, e, item, "modal_update_open")}>
            <div className="contact-name">{item.name}</div>
            <Labels label_list={label_list} item_labels={item.labels} displayMode />
          </div></div>;
        }.bind(this));
        card = <div className="card contacts">{cards}</div>;
      }
    }

    if(page_cards === undefined || page_cards.isFetching) {
      end_of_list_text = "Loading..";
      list_title = "Contacts";
    } else if((page_cards !== undefined && !page_cards.isFetching && page_cards.limitReached)) {
      if(page_cards.data[0] !== undefined) {
        end_of_list_text = "End of results.";
        list_title = "Contacts ("+page_cards.data.length+")";
      } else {
        end_of_list_text = "No contacts.";
        list_title = "Contacts (0)";
      }
    }

    let sortbytext = "sort by created";
    if(!this.state.sortbyname) sortbytext = "sort by name";

    return (
      <div className="container content" ref={(node) => this.setWrapperRef(node)}>
        <div className="card-layout">
          <div className="card-layout-div50"><strong>{list_title}</strong></div>
          <div className="card-layout-div50 index-actions">
            {page_cards !== undefined && <button className="btn" style={{marginRight:"10px"}} onClick={() => this.setState({sortbyname:!this.state.sortbyname})}>{sortbytext}</button>}
            {page_cards !== undefined && <button className="btn" style={{marginRight:"10px"}} onClick={() => openModal(this, null, null, "modal_create_open")}>new</button>}
            <img src={refresh_icon} alt="Refresh" onClick={() => this.refresh()}/>
          </div>
        </div>
        {card}
        <div className="end_of_list_text">{end_of_list_text}</div>

        <ModalUpdateContact shouldShow={this.state.modal_update_open} close={() => closeModal(this, "modal_update_open")} update_data={this.state.modal_content} label_list={this.props.apiData["label_list"]} />
        <ModalCreateContact shouldShow={this.state.modal_create_open} close={() => closeModal(this, "modal_create_open")} label_list={this.props.apiData["label_list"]} />
      </div>
    );
  }

  refresh() {
    this.props.clearStateBlock("contact_list");
    this.props.clearStateBlock("label_list");
    this.setState({"page":0});  
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Contacts)



// WEBPACK FOOTER //
// ./src/containers/Contacts.js